export const ArchivedChatGeneric = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3957_2480)">
      <path
        d="M14.6641 6.6665C15.032 6.6667 15.3301 6.9655 15.3301 7.3335V12.6655C15.3279 14.505 13.8375 15.9961 11.998 15.9985H3.99902C2.15944 15.9962 0.669179 14.5051 0.666992 12.6655V7.3335C0.666992 6.96541 0.964926 6.66654 1.33301 6.6665H14.6641ZM5.99902 8.6665C5.63105 8.6665 5.33225 8.96459 5.33203 9.33252C5.33203 9.70063 5.63091 9.99951 5.99902 9.99951H9.99805C10.3661 9.99948 10.6641 9.70061 10.6641 9.33252C10.6638 8.96461 10.366 8.66654 9.99805 8.6665H5.99902ZM12.6641 0.00146484C12.7125 0.00146484 12.7612 0.00226996 12.8096 0.00439453C14.6501 0.0847802 16.0773 1.64235 15.9971 3.48291C15.9287 4.53337 15.0497 5.34634 13.9971 5.3335H2C0.895781 5.3335 0.000197482 4.43865 0 3.33447C0 1.49391 1.49241 0.00146484 3.33301 0.00146484H12.6641Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3957_2480">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
